import {
  PlanOfferDetails,
  PrimaryCategory,
  WearableEligibilityCheckSteps,
  WearableEligibilitySection,
  WearableEligibilityType,
} from 'journey/productDetails/typings';
import { extractFirstValue } from './query.utils';

interface IsWearableParameter {
  categoryIds: string | readonly string[];
}

interface GetPlanCategory {
  routePlanId: string | string[];
  planOffers: PlanOfferDetails;
}

interface GetWearableCheckEligibilitySection {
  isSamsungWearable: boolean;
  wearableEligibility: WearableEligibilityType;
}
export const isWearable = ({ categoryIds }: IsWearableParameter): boolean => {
  if (typeof categoryIds === 'object') {
    return categoryIds.includes(PrimaryCategory.WEARABLES);
  }
  return categoryIds === PrimaryCategory.WEARABLES;
};

export const getPlanCategory = ({
  routePlanId,
  planOffers,
}: GetPlanCategory): string[] => {
  const planId = extractFirstValue(routePlanId);

  const selectedPlan =
    planOffers?.find((offer) => offer.id === planId) ?? planOffers?.[0];

  return selectedPlan?.category?.map((category) => category.id) || [];
};

export const getWearableCheckEligibilitySection = ({
  isSamsungWearable,
  wearableEligibility,
}: GetWearableCheckEligibilitySection): WearableEligibilitySection[] => {
  if (isSamsungWearable) {
    return [
      {
        id: 0,
        name: 'Account',
        value: WearableEligibilityCheckSteps.AccountSelection,
      },
    ];
  }

  return wearableEligibility.sections;
};
